export default {
  metaTitle: "USFans Spreadsheet 2026: Guía completa y lo que necesitas saber",
  metaDescription:
    "Una guía independiente completa de la USFans Spreadsheet: qué es, cómo funciona, categorías principales, consejos de compra, QC, envío y seguridad. Actualizada 2026.",
  breadcrumbHome: "Inicio",
  breadcrumbCurrent: "Guía de USFans Spreadsheet",
  h1: "USFans Spreadsheet 2026: Guía completa y lo que necesitas saber",
  shortAnswerLabel: "Respuesta corta",
  shortAnswer:
    "La USFans Spreadsheet es un recurso de productos organizado que te ayuda a descubrir hallazgos, comparar categorías y entender cómo comprar mejor — antes de hacer un pedido.",
  intro1:
    "Si has estado buscando una forma clara y honesta de explorar los hallazgos de USFans, estás en el lugar correcto. Esta guía explica qué es la USFans Spreadsheet, cómo funciona y cómo usarla para tomar decisiones de compra más seguras.",
  intro2:
    "Mantenemos este recurso independiente y práctico. Aquí no encontrarás promesas exageradas — solo información directa sobre categorías, QC, envío y seguridad, para que puedas explorar con confianza.",
  tocTitle: "Tabla de contenidos",
  toc1: "¿Qué es la USFans Spreadsheet?",
  toc2: "Cómo funciona la USFans Spreadsheet",
  toc3: "Categorías principales que encontrarás",
  toc4: "Una guía de compra rápida",
  toc5: "Básicos de QC, envío y almacén",
  toc6: "¿USFans es legítimo y seguro?",
  s1Title: "¿Qué es la USFans Spreadsheet?",
  s1Body:
    "La USFans Spreadsheet es una colección curada de enlaces y recursos de productos, organizada por categoría. En lugar de buscar entre páginas dispersas, puedes ir directo a la sección que necesitas — desde zapatos y sudaderas hasta bolsos y accesorios. El objetivo es simple: hacer que el descubrimiento de productos sea más rápido y menos confuso.",
  s2Title: "Cómo funciona la USFans Spreadsheet",
  s2Body:
    "La hoja está organizada por categoría, así que siempre sabes dónde buscar. Elige una categoría, explora los hallazgos disponibles y sigue los enlaces al sitio principal para ver los detalles, precios y disponibilidad actuales. Como la información cambia con frecuencia, verifica siempre los detalles más recientes en las páginas enlazadas antes de comprar.",
  s3Title: "Categorías principales que encontrarás",
  s3Body:
    "Encontrarás más de una docena de categorías, incluyendo Zapatos, Sudaderas y Jerséis, Camisetas, Chaquetas, Pantalones y Cortos, Gorras, Conjuntos, Ropa interior, Camisetas deportivas, Accesorios, Bolsos, Cinturones, Perfumes y Otras cosas. Cada categoría agrupa productos similares para que puedas comparar opciones sin cambiar entre muchas pestañas.",
  s4Title: "Una guía de compra rápida",
  s4Body:
    "Antes de pedir, sigue unos pasos simples. Primero, revisa con cuidado las fotos del producto. Segundo, revisa la guía de tallas si está disponible. Tercero, compara un par de artículos similares antes de decidirte. Por último, confirma el precio actual y los detalles de envío en el sitio principal — estos pueden cambiar con el tiempo.",
  s5Title: "Básicos de QC, envío y almacén",
  s5Body:
    "Muchos compradores preguntan sobre QC (control de calidad), envío y manejo del almacén. En términos simples, QC significa revisar las fotos del producto antes de aprobarlo, el envío depende del peso, las dimensiones y el destino, y el almacén es donde los artículos se guardan y preparan antes de enviártelos. Entender estos básicos te ayuda a evitar sorpresas.",
  s6Title: "¿USFans es legítimo y seguro?",
  s6Body:
    "Es una pregunta justa antes de cualquier compra en línea. No hacemos afirmaciones absolutas sobre seguridad, y ninguna plataforma está libre de riesgos. El mejor enfoque es verificar los detalles del producto, revisar la información del vendedor, mirar las fotos de QC y leer las políticas actuales antes de pedir. Ser precavido es la forma más eficaz de protegerte.",
  tableTitle: "Funciones clave de un vistazo",
  tableCol1: "Función",
  tableCol2: "Qué saber",
  tableCol3: "Consideración importante",
  t1c1: "Descubrimiento de productos",
  t1c2: "Hoja / recursos",
  t1c3: "Verifica la información actual",
  t2c1: "QC",
  t2c2: "Recursos de inspección",
  t2c3: "Revisa las fotos con cuidado",
  t3c1: "Envío",
  t3c2: "Varias consideraciones",
  t3c3: "Los costos varían según el destino",
  t4c1: "Devoluciones",
  t4c2: "Depende de la política",
  t4c3: "Revisa los términos actuales",
  faqTitle: "Preguntas frecuentes",
  faq1Q: "¿Qué es la USFans Spreadsheet?",
  faq1A:
    "Es un recurso organizado que agrupa los hallazgos de productos de USFans por categoría, facilitando explorar y comparar opciones en un solo lugar.",
  faq2Q: "¿Explorar la USFans Spreadsheet es gratis?",
  faq2A:
    "El recurso en sí es gratis. Solo necesitas revisar el sitio principal para ver los detalles, precios y disponibilidad actuales de los productos.",
  faq3Q: "¿Necesito una cuenta para usar la hoja?",
  faq3A:
    "Explorar no requiere cuenta. Si decides comprar, sigue los enlaces al sitio principal y completa el pago allí.",
  faq4Q: "¿Con qué frecuencia se actualiza la hoja?",
  faq4A:
    "Buscamos mantener el recurso organizado y actualizado. Sin embargo, los detalles de los productos cambian con frecuencia, así que verifica siempre la información más reciente en las páginas enlazadas.",
  faq5Q: "¿USFans es seguro de usar?",
  faq5A:
    "No podemos garantizar la seguridad de ninguna plataforma. Usa precaución, verifica los detalles y lee las políticas actuales antes de pedir.",
  ctaTitle: "Sigue explorando",
  ctaSub: "¿Listo para explorar? Ve al sitio principal o vuelve al inicio para ver más guías.",
  ctaPrimary: "Explorar la USFans Spreadsheet",
  ctaSecondary: "Volver al inicio",
  updatedLabel: "Última actualización:",
  updatedValue: "2026",
  authorLabel: "Escrito y revisado por el equipo editorial de USFansSheet",
  disclaimerTitle: "Aviso legal",
  disclaimerBody:
    "Este artículo es solo informativo. USFansSheet es un recurso independiente y no está afiliado con USFans. Verifica siempre los detalles, precios y políticas actuales en las páginas oficiales antes de realizar una compra.",
};